import { render, staticRenderFns } from "./RegistrationAndLoginSupport.vue?vue&type=template&id=f73c464a&"
import script from "./RegistrationAndLoginSupport.vue?vue&type=script&lang=js&"
export * from "./RegistrationAndLoginSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports